import { render, staticRenderFns } from "./Vehicle2.vue?vue&type=template&id=98afe3e0&scoped=true"
import script from "./Vehicle2.vue?vue&type=script&lang=js"
export * from "./Vehicle2.vue?vue&type=script&lang=js"
import style0 from "./Vehicle2.vue?vue&type=style&index=0&id=98afe3e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98afe3e0",
  null
  
)

export default component.exports